/**
 * The brand, available synchronously on the very first render.
 *
 * Fetching it was the bug. The page painted the default name and colour, then
 * repainted with the real ones a moment later, and the switch was plainly
 * visible - Ben saw it twice, first as red-then-blue and then as ZONE-then-CF.
 * No amount of JavaScript fixes that: anything asynchronous happens after the
 * first paint by definition.
 *
 * So the container bakes the values into index.html at startup (see
 * frontend/entrypoint.sh) and this reads what is already in the document. No
 * request, no flash. An instance with nothing baked - `npm start`, or a
 * deployment that predates this - falls back to the Zone defaults, which is
 * exactly what those instances should show.
 *
 * Zone is the PRODUCT. Zeta One is the COMPANY selling it. A reseller replaces
 * them independently, so they are two settings, not one.
 */
const BAKED = (typeof window !== 'undefined' && window.__BRAND__) || {};

const brand = {
  productName: BAKED.productName || 'Zone',
  companyName: BAKED.companyName || 'Zeta One',
  primaryColor: BAKED.primaryColor || '#ba232e',
  primaryColorDark: BAKED.primaryColorDark || '#9c1d27',
  primaryColorLight: BAKED.primaryColorLight || '#d42a37',
  // Empty string when the instance has not uploaded one - callers fall back to
  // the product name in text.
  logoUrl: BAKED.logoUrl || '',
  logoLightUrl: BAKED.logoLightUrl || ''
};

export default brand;
